<template>
  <div class="wrapper">
    <parallax class="section "> </parallax>
    <div class="main">
      <div class="section section-contacts">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-70 md-xsmall-size-100 mx-auto">
              <b-breadcrumb id="inNav" style="background:transparent;">
                <b-breadcrumb-item
                  style="//styleName: Title;
font-family: Noto Serif JP;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 28px;
letter-spacing: 0em;
text-align: left;
"
                  href="/"
                  >Home</b-breadcrumb-item
                >
                <b-breadcrumb-item
                  style="color: #c1a360 !important; //styleName: Title;
font-family: Noto Serif JP;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 28px;
letter-spacing: 0em;
text-align: left;
"
                  active
                  >About us</b-breadcrumb-item
                >
              </b-breadcrumb>
              <h2 class="title">About Your Place</h2>
              <h4 class="Details">
                By aiming to take the life quality to an upper level with the
                whole realized Projects of luxury.
              </h4>
              <div class="row">
                <div class="col-md">
                  <h4 class=" description">
                    Eventually, you do plan to have dinosaurs on your dinosaur
                    tour, right? Remind me to thank John for a lovely weekend.
                    Just my luck, no ice. Yeah, but your scientists were so
                    preoccupied with whether or not they could, they didn't stop
                    to think if they should. You're a very talented young man,
                    with your own clever thoughts and ideas. Do you need a
                    manager? You really think you can fly that thing? They're
                    using our own satellites against us. And the clock is
                    ticking. Hey, take a look at the earthlings. Goodbye! Remind
                    me to thank John for a lovely weekend. Hey, you know how
                    I'm, like, always trying to save the planet? Here's my
                    chance. Did he just throw my cat out of the window? I was
                    part of something special. God help us, we're in the hands
                    of engineers. What do they got in there? King Kong? You
                    really think you can fly that thing? Yeah, but your
                    scientists were so preoccupied with whether or not they
                    could, they didn't stop to think if they should.
                    Checkmate... What do they got in there? King Kong? Just my
                    luck, no ice. Do you have any idea how long it takes those
                    cups to decompose. They're using our own satellites against
                    us. And the clock is ticking. Must go faster. You know what?
                    It is beets. I've crashed into a beet truck. Did he just
                    throw my cat ou
                  </h4>
                </div>
                <div class="col-md">
                  <img src="@/assets/img/yourplace/side-image01 1.png" />
                </div>
              </div>
              <h4 class="Details">
                Property Specification
              </h4>
              <div class="row">
                <div class="col-md">
                  <h4 class=" description">
                    Eventually, you do plan to have dinosaurs on your dinosaur
                    tour, right? Remind me to thank John for a lovely weekend.
                    Just my luck, no ice. Yeah, but your scientists were so
                    preoccupied with whether or not they could, they didn't stop
                    to think if they should. You're a very talented young man,
                    with your own clever thoughts and ideas. Do you need a
                    manager? You really think you can fly that thing? They're
                    using our own satellites against us. And the clock is
                    ticking. Hey, take a look at the earthlings. Goodbye! Remind
                    me to thank John for a lovely weekend. Hey, you know how
                    I'm, like, always trying to save the planet? Here's my
                    chance. Did he just throw my cat out of the window? I was
                    part of something special. God help us, we're in the hands
                    of engineers. What do they got in there? King Kong? You
                    really think you can fly that thing? Yeah, but your
                    scientists were so preoccupied with whether or not they
                    could, they didn't stop to think if they should.
                    Checkmate... What do they got in there? King Kong? Just my
                    luck, no ice. Do you have any idea how long it takes those
                    cups to decompose. They're using our own satellites against
                    us. And the clock is ticking. Must go faster. You know what?
                    It is beets. I've crashed into a beet truck. Did he just
                    throw my cat out
                  </h4>
                </div>
              </div>
              <h4 class="Details">
                Our Team
              </h4>
              <div class="team">
                <div class="md-layout">
                  <div
                    class="md-layout-item md-medium-size-33 md-small-size-100"
                  >
                    <div class="team-player">
                      <md-card class="md-card-plain">
                        <div class="md-layout-item md-size-50 mx-auto">
                          <img
                            :src="teamImg1"
                            alt="Thumbnail Image"
                            class="img-raised rounded-circle img-fluid"
                          />
                        </div>
                        <h4 class="card-title">
                          Gigi Hadid
                          <br />
                          <small class="card-description text-muted"
                            >Model</small
                          >
                        </h4>

                        <md-card-content>
                          <p class="card-description">
                            You can write here details about one of your team
                            members. You can give more details about what they
                            do. Feel free to add some <a href="#">links</a> for
                            people to be able to follow them outside the site.
                          </p>
                        </md-card-content>

                        <md-card-actions class="text-center">
                          <md-button
                            href="javascript:void(0)"
                            class="md-just-icon md-simple"
                          >
                            <i class="fab fa-twitter"></i>
                          </md-button>
                          <md-button
                            href="javascript:void(0)"
                            class="md-just-icon md-simple"
                          >
                            <i class="fab fa-instagram"></i>
                          </md-button>
                          <md-button
                            href="javascript:void(0)"
                            class="md-just-icon md-simple"
                          >
                            <i class="fab fa-facebook-square"></i>
                          </md-button>
                        </md-card-actions>
                      </md-card>
                    </div>
                  </div>
                  <div
                    class="md-layout-item md-medium-size-33 md-small-size-100"
                  >
                    <div class="team-player">
                      <md-card class="md-card-plain">
                        <div class="md-layout-item md-size-50 mx-auto">
                          <img
                            :src="teamImg2"
                            alt="Thumbnail Image"
                            class="img-raised rounded-circle img-fluid"
                          />
                        </div>
                        <h4 class="card-title">
                          Carla Hortensia
                          <br />
                          <small class="card-description text-muted"
                            >Designer</small
                          >
                        </h4>

                        <md-card-content>
                          <p class="card-description">
                            You can write here details about one of your team
                            members. You can give more details about what they
                            do. Feel free to add some <a href="#">links</a> for
                            people to be able to follow them outside the site.
                          </p>
                        </md-card-content>

                        <md-card-actions class="text-center">
                          <md-button
                            href="javascript:void(0)"
                            class="md-just-icon md-simple"
                          >
                            <i class="fab fa-twitter"></i>
                          </md-button>
                          <md-button
                            href="javascript:void(0)"
                            class="md-just-icon md-simple"
                          >
                            <i class="fab fa-linkedin"></i>
                          </md-button>
                        </md-card-actions>
                      </md-card>
                    </div>
                  </div>
                  <div
                    class="md-layout-item md-medium-size-33 md-small-size-100"
                  >
                    <div class="team-player">
                      <md-card class="md-card-plain">
                        <div class="md-layout-item md-size-50 mx-auto">
                          <img
                            :src="teamImg3"
                            alt="Thumbnail Image"
                            class="img-raised rounded-circle img-fluid"
                          />
                        </div>
                        <h4 class="card-title">
                          Kendall Jenner
                          <br />
                          <small class="card-description text-muted"
                            >Model</small
                          >
                        </h4>

                        <md-card-content>
                          <p class="card-description">
                            You can write here details about one of your team
                            members. You can give more details about what they
                            do. Feel free to add some <a href="#">links</a> for
                            people to be able to follow them outside the site.
                          </p>
                        </md-card-content>

                        <md-card-actions class="text-center">
                          <md-button
                            href="javascript:void(0)"
                            class="md-just-icon md-simple"
                          >
                            <i class="fab fa-twitter"></i>
                          </md-button>
                          <md-button
                            href="javascript:void(0)"
                            class="md-just-icon md-simple"
                          >
                            <i class="fab fa-instagram"></i>
                          </md-button>
                          <md-button
                            href="javascript:void(0)"
                            class="md-just-icon md-simple"
                          >
                            <i class="fab fa-facebook-square"></i>
                          </md-button>
                        </md-card-actions>
                      </md-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "aboutus",
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bg7.jpg")
    },
    teamImg1: {
      type: String,
      default: require("@/assets/img/faces/avatar.jpg")
    },
    teamImg2: {
      type: String,
      default: require("@/assets/img/faces/christian.jpg")
    },
    teamImg3: {
      type: String,
      default: require("@/assets/img/faces/kendall.jpg")
    }
  },
  data() {
    return {
      name: null,
      email: null,
      message: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
#inNav > li > a {
  color: black;
}

.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}

.md-outline input:focus {
  border-color: #c1a360 !important;
  box-shadow: inset 0 0 0 1px #c1a360 !important;
  border-bottom: 1px solid #c1a360 !important;
}

.md-outline label.active {
  color: #c1a360 !important;
}

.md-toolbar.md-transparent .md-title,
.md-toolbar.md-transparent .md-list .md-list-item-content,
.md-toolbar.md-transparent .md-list-item-container .md-icon,
.md-toolbar.md-transparent,
.md-toolbar.md-transparent:hover,
.md-toolbar.md-transparent:focus {
  color: black !important;
}
.Details {
  // font-family: Noto Sans JP !important;
  //styleName: H4;
  font-family: Noto Serif JP;
  font-size: 26px;
  font-style: normal;
  font-weight: 900;
  line-height: 40px;
  letter-spacing: 0em;
  text-align: left;

  color: #c1a360 !important;
}
.title {
  //styleName: Hero;
  font-family: Noto Serif JP !important;
  font-size: 65px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 96px !important;
  letter-spacing: 0em !important;
  text-align: left !important;
  color: black !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
